import React from 'react';
import styled from 'styled-components';

const BannerWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(135deg, #00ce77 0%, #009053 100%);
  color: white;
  padding: 24px 40px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 8px 32px rgba(0, 206, 119, 0.3);
  border-radius: 16px;
  max-width: 450px;
`;

const PulsingDot = styled.span`
  width: 8px;
  height: 8px;
  background-color: #10B981;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
      transform: scale(1.2);
    }
  }
`;

interface MeetGreetBannerProps {
  message?: string;
}

const MeetGreetBanner: React.FC<MeetGreetBannerProps> = ({
  message = "Your tutor will enter shortly. Please wait..."
}) => {
  return (
    <BannerWrapper>
      <PulsingDot />
      {message}
    </BannerWrapper>
  );
};

export default MeetGreetBanner;
